/**
 * 会话行（W-15 列表 + W-16 左栏共用，story AC-4/AC-6）。
 * 口径引用源 Screen-18：头像/昵称/相对时间/预览(≤30 已截)/未读 Badge(≤0 不渲染, >99→99+)。
 */
import type { ConversationItem } from '@/api/im';
import { formatRelativeTime } from '@/lib/timeFormat';

interface ConversationRowProps {
  item: ConversationItem;
  active?: boolean;
  onSelect: (item: ConversationItem) => void;
}

function displayNickname(item: ConversationItem): string {
  return item.peerNickname && item.peerNickname.trim() !== ''
    ? item.peerNickname
    : `用户 ${item.peerUserId ?? ''}`.trim();
}

function avatarInitial(item: ConversationItem): string {
  const name = item.peerNickname?.trim();
  return name ? name.slice(0, 1) : '?';
}

function unreadLabel(count: number | undefined): string | null {
  const n = count ?? 0;
  if (n <= 0) return null;
  return n > 99 ? '99+' : String(n);
}

export function ConversationRow({ item, active, onSelect }: ConversationRowProps) {
  const timeText = formatRelativeTime(item.lastMessageAt);
  const preview = item.lastMessage?.content ?? '暂无消息';
  const badge = unreadLabel(item.unreadCount);

  return (
    <button
      type="button"
      className="list-item"
      onClick={() => onSelect(item)}
      style={{
        width: '100%',
        textAlign: 'left',
        background: active ? 'var(--color-secondary)' : undefined,
        cursor: 'pointer',
      }}
    >
      <span className="avatar" aria-label={item.peerAvatar ? undefined : 'default-avatar'}>
        {avatarInitial(item)}
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="row between" style={{ marginBottom: 'var(--space-1)' }}>
          <span style={{ fontWeight: 'var(--weight-semibold)' }}>{displayNickname(item)}</span>
          {timeText.length > 0 && <span className="xs muted">{timeText}</span>}
        </div>
        <div
          className="sm muted"
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {preview}
        </div>
      </div>
      {badge && <span className="badge badge-primary">{badge}</span>}
    </button>
  );
}
